import { BasicFrame } from 'components/organisms';
import { frameConfigBasicTink } from '../../AppConfig';
import { LightbulbIcon } from 'components/icons';
import { ROUTES } from 'utils/constants/constants_routes';
import { useCustomNavigation } from 'hooks/useCustomNavigation';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Card from 'components/atoms/Card/Card';
import classes from 'classnames';
import styles from './TinkBankIssue.module.scss';

export default function TinkBankIssue() {
  const { t } = useTranslation('tinkBankIssue');
  const { navigateToOnlineBankVerification } = useCustomNavigation();
  const navigate = useNavigate();

  const onDocCardHandler = () => {
    navigate(
      `${ROUTES.FIRST_LOAN_MANUAL_UPLOAD}?backRoute=${ROUTES.FIRST_LOAN_TINK_BANK_ISSUE}`,
    );
  };

  const onLaterCardHandler = () => {
    navigate(ROUTES.FIRST_LOAN_TINK_LATER);
  };

  return (
    <BasicFrame
      {...frameConfigBasicTink}
      headerLayout="centered"
      onBackBtnHandler={navigateToOnlineBankVerification}
    >
      <div className={styles.layout} data-test="tinkBankIssue-layout">
        <div className={styles.title} data-test="tinkBankIssue-title">
          {t('title')}
        </div>
        <Card className={styles['doc-card']} data-test="tinkBankIssue-docCard">
          <div
            className={styles.content}
            data-test="tinkBankIssue-docCard-content"
          >
            {t('docCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankIssue-docButton"
            onClick={onDocCardHandler}
          >
            {t('docCard.ctoDoc')}
          </button>
          <button
            className={classes(styles.button, styles['retry-button'])}
            data-test="tinkBankIssue-retryButton"
            onClick={navigateToOnlineBankVerification}
          >
            {t('docCard.ctoRetry')}
          </button>
        </Card>
        <Card
          className={styles['later-card']}
          data-test="tinkBankIssue-laterCard"
        >
          <div
            className={styles.heading}
            data-test="tinkBankIssue-laterCard-heading"
          >
            <LightbulbIcon data-test="tinkBankIssue-laterCard-lightbulb" />
            <div
              className={styles.title}
              data-test="tinkBankIssue-laterCard-title"
            >
              {t('laterCard.title')}
            </div>
          </div>
          <div
            className={styles.content}
            data-test="tinkBankIssue-laterCard-content"
          >
            {t('laterCard.content')}
          </div>
          <button
            className={styles.button}
            data-test="tinkBankIssue-laterCard-button"
            onClick={onLaterCardHandler}
          >
            {t('laterCard.cto')}
          </button>
        </Card>
      </div>
    </BasicFrame>
  );
}
